import React, { Component } from 'react'
import { DateRange } from 'react-date-range'
import Icon from 'react-fontawesome'
import moment from 'moment'
import styled from 'styled-components'
import t from 'prop-types'

import Color from 'helpers/Color'
import { Button } from 'components/UI'

const Wrapper = styled.div`
  &:focus {
    outline: none;
  }
`
const Popup = styled.div`
  position: absolute;
  left: 0;
  margin-right: auto;
  margin-left: auto;
  margin-top: 10px;
  right: 0;
  width: 600px;
  border-radius: 10px;
  background-color: ${Color.white};
  padding: 10px;
  ${'' /* border: solid 10px ${Color.white}; */}
  border: solid 3px ${Color.green};
  z-index: 2;
`
const DateButton = styled.div`
  display: inline-block;
  font-size: 1.2em;
  cursor: pointer;
  margin-right: 10px;
`
const DateIcon = styled(Icon)`
  margin-right: 5px;
  margin-left: 10px;
`
const Description = styled.div`
  color: ${Color.green};
  display: inline-block;
`
const Background = styled.div`
  z-index: 1;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

const DateRangeTheme = {
  MonthButton: {
    background: Color.green,
    cursor: 'pointer',
  },
  MonthArrowPrev  : {
    borderRightColor  : Color.white,
  },
  MonthArrowNext  : {
    borderLeftColor  : Color.white,
  },
  DaySelected: {
    background: Color.green,
  },
  DayActive: {
    background: Color.green,
  },
  DayInRange: {
    background: Color.green,
    color: Color.white,
  },
  DayHover: {
    background: Color.lightGreen,
    color: Color.white,
  },
}

export default class DatePicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
    }
    this.initial = {
      startDate: moment(props.from),
      endDate: moment(props.to),
    }
  }

  hide = () => {
    this.setState({
      visible: false,
    })
  }

  toggleVisible = () => {
    this.setState({
      visible: !this.state.visible,
    })
  }

  handleDateChange = range => {
    if (range.startDate.isSame(range.endDate)) return
    this.props.onChange(range)
    this.hide()
  }

  handleResetClick = () => {
    this.handleDateChange(this.initial)
  }

  render () {
    const {
      from,
      to,
    } = this.props

    const fromText = moment(from).format('MMM D, YYYY')
    const toText = moment(to).format('MMM D, YYYY')

    return (
      <Wrapper>
        <Description>
          To update the graphs below, please select a date range:
        </Description>
        <DateButton onClick={this.toggleVisible}>
          <DateIcon name='calendar' fixedWidth />
          {`${fromText} - ${toText}`}
        </DateButton>
        <Button compact onClick={this.handleResetClick}>
          Reset Range
        </Button>
        { this.state.visible && [
          <Popup key='popup'>
            <DateRange
              startDate={moment(from)}
              endDate={moment(to)}
              onChange={this.handleDateChange}
              theme={DateRangeTheme}
            />
          </Popup>,
          // Close popup when clicking outside it
          <Background
            key='background'
            onClick={this.hide}
          />,
        ]}
      </Wrapper>
    )
  }
}

DatePicker.propTypes = {
  onChange: t.func.isRequired,
  from: t.number.isRequired,
  to: t.number.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/UI/DatePicker.jsx